import type { ExternalTableSchema } from '@packages/table-builder';

export const tradingBlackoutConfigTable: ExternalTableSchema = {
  metadata: {
    title: 'Trading Blackout Configuration',
    description: 'Manage your trading blackout configuration.',
    entity: 'TradingBlackoutConfig',
  },

  dataSource: {
    endpoint: '/api/customer/api/app/blackout/blackout-list',
    method: 'GET',
    rowIdField: 'blackoutId',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Sorting: 'table.sorting',
      SkipCount: 'table.pageOffset',
      MaxResultCount: 'table.pageSize',
    },
  },

  columns: [
    { field: 'blackoutTitle', header: 'Blackout Title', sortable: true, width: 180 },
    { field: 'startDate', header: 'Start Duration', type: 'dateTime', sortable: false, width: 180 },
    { field: 'endDate', header: 'End Duration', type: 'dateTime', sortable: false, width: 180 },
    { field: 'eligibleFor', header: 'Eligible For', sortable: false, width: 150 },
    { field: 'creationTime', header: 'Creation Time', type: 'dateTime', sortable: true, width: 150 },
    { field: 'lastModifiedDate', header: 'Last Modified', type: 'dateTime', sortable: true, width: 150 },
  ],

  actions: {
    toolbar: {
      primary: { id: 'ADD_TRADING_BLACKOUT_CONFIG', label: 'Add Blackout', icon: 'add_circle_outline' },
    },
    row: [
      { id: 'VIEW_TRADING_BLACKOUT_CONFIG', label: 'View' },
      { id: 'EDIT_TRADING_BLACKOUT_CONFIG', label: 'Edit' },
      { id: 'REPURPOSE_TRADING_BLACKOUT_CONFIG', label: 'Repurpose' },
      { id: 'DELETE_TRADING_BLACKOUT_CONFIG', label: 'Delete', variant: 'danger' },
    ],
  },

  features: {
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'Trading Blackout Config', resizable: true, reorderable: true },
  },
};
